import { notFound } from "@tanstack/react-router";
import { createServerFn } from "@tanstack/react-start";
import { siteContext } from "../server/site.server";
import { compareHub, comparePage } from "./compare.server";
import { platformPageResponse } from "./page-response";
import { regularPlanShown } from "./plan-flag.server";

/** /compare, on Drate's own host only; a creator's site answers it with its own 404. */
export const loadCompareHub = createServerFn({ method: "GET" }).handler(async ({ context }) => {
  const drate = await siteContext(context);
  if (drate.creator) return null;
  platformPageResponse(drate);
  return compareHub(drate.env.APP_ORIGIN, await regularPlanShown(drate));
});

/** /compare/<platform> and /compare/<platform>-alternative, on Drate's own host only. */
export const loadComparePage = createServerFn({ method: "GET" })
  .validator((slug: unknown) => {
    if (typeof slug !== "string" || !/^[a-z0-9-]{1,80}$/.test(slug)) throw notFound();
    return slug;
  })
  .handler(async ({ data: slug, context }) => {
    const drate = await siteContext(context);
    if (drate.creator) return null;
    platformPageResponse(drate);
    return comparePage(drate.env.APP_ORIGIN, slug, await regularPlanShown(drate));
  });
